import { useQuery } from '@tanstack/react-query';

import { useWmgSession } from '~/modules/auth/hooks/useWmgSession';

import { ddexImportQueryKeys } from '../config/queryKeys';
import { DdexClient } from '../lib/DdexClient';
import { getRequestHeaders } from '../lib/headers';
import type { DdexImportStatusCounts } from '../lib/schemas';
import { DdexImportStatusCountsSchema } from '../lib/schemas';
import type { PresetUseQueryOptions } from '../lib/types';

export function useImportStatusCounts<TData = DdexImportStatusCounts>(
  options?: PresetUseQueryOptions<DdexImportStatusCounts, TData>,
) {
  const session = useWmgSession();

  const { data, ...query } = useQuery({
    queryKey: ddexImportQueryKeys.statusCounts(),
    queryFn: async () => {
      const responseData = await DdexClient.get(
        'v1/releases/history/status-counts',
        {
          headers: getRequestHeaders(session.token),
        },
      ).json();

      return DdexImportStatusCountsSchema.parse(responseData);
    },
    staleTime: 60_000,
    ...options,
  });

  return { importStatusCounts: data, ...query };
}
